'use client';

import { Link, useNavigate } from 'react-router-dom';
import { useVendor } from '@/contexts/VendorContext';
import { ChevronLeft, Search, User } from 'lucide-react';
import { useUser } from '@/contexts/UserContext';

export default function HeroHeader({ setCategories }) {
  const { selectedVendor, vendors, setSelectedVendor } = useVendor();
  const { user } = useUser();
  const userRole = user?.userType;
  const navigate = useNavigate();
  const selectedLocalVendor =
    selectedVendor || JSON.parse(localStorage.getItem('selectedVendor') || '{}');

  return (
    <div className="w-full min-h-[4.5rem]">
      {/* Header */}
      <header className="bg-white fixed w-full max-w-md top-0 z-30 shadow-sm">
        <div className="max-w-md mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div onClick={() => navigate('/')}>
                <ChevronLeft className="w-6 h-6 cursor-pointer" />
              </div>
              <div className="text-xl text-green-700 font-bold">
                <img
                  src="/images/biglocallogo3.png"
                  alt="SubziWale Logo"
                  className="w-28 object-contain"
                  loading="eager"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <Link to="search" aria-label="Search" className="p-1">
                <button className="flex items-center pl-3 py-1 w-fit overflow-hidden border-2 border-black/20 rounded-lg">
                  <Search className="h-5 w-5 text-black/30" />
                  <input
                    type="text"
                    className="w-24 px-3 focus:outline-none focus:border-none"
                    placeholder="Search..."
                  />
                </button>
              </Link>
              <Link to={userRole === 'vendor' ? '/vendor/profile' : '/profile'}>
                <div className="h-9 w-9 rounded-full bg-green-700 text-white flex items-center justify-center  font-medium">
                  {/* {user?.name?.slice(0, 1) || 'JD'} */}
                  {user?.name?.slice(0, 1) === '+' ? (
                    <User className="w-8" />
                  ) : (
                    user?.name?.slice(0, 1) || <User className="w-8" />
                  )}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
